import { withInstall } from '../../utils/install';
import CollapsePanel from '../ivue-collapse/panel.vue';

export const IvueCollapsePanel = withInstall(CollapsePanel);
export default IvueCollapsePanel;

export * from '../ivue-collapse/panel.vue';
